import styled from '@emotion/styled';
import { TextareaAutosize } from '@mui/material';
import { spacing } from '@mui/system';

export default styled(TextareaAutosize)<{ my?: number }>(spacing);
